package com.devi3east.bashbuddy.purchase.requests

import kotlinx.serialization.Serializable

@Serializable
data class PurchaseInitRequest(
    val items: List<PurchaseItemRequest>,
    val jurisdictionEligibilityConfirmed: Boolean,
    val successUrl: String? = null,
    val cancelUrl: String? = null
)